import React, { SyntheticEvent, useContext, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import CreationTag from '../../tag'
import Instructions from '../field-instructions'
import Title from '../field-title'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;
    margin-bottom: -10px;
`

const Wrapper = styled.div`
    display: flex;
`

const Tags = styled.div`
    margin-top: 15px;
`

const Tag = styled(CreationTag)`
    margin: 0 8px 10px 0;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceId?: string
}

const CreationUploadTagsField = ({ className, field, sourceId }: Props) => {
    const { uploadSources, tags, addTags, removeTags } = useContext(CreationToolUploadContext)
    const [displayTags, setDisplayTags] = useState<string[]>([])
    const inputRef = useRef<HTMLInputElement>(null)
    const description = CreationToolUploadField.description(field)

    useEffect(() => {
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            if (source) {
                setDisplayTags(source.tags)
            }
        } else {
            setDisplayTags(tags)
        }
    }, [tags, sourceId, uploadSources])

    const setTags = () => {
        if (!inputRef.current) return

        // split tags by comma and add them to the list
        const tags = (inputRef.current.value || '').split(',')
        tags.length && addTags(tags, false, sourceId)
        inputRef.current.value = ''
    }

    const onKeyDown = (e: SyntheticEvent<HTMLInputElement, KeyboardEvent>) => {
        e.nativeEvent.key === 'Enter' && setTags()
    }

    const onTagRemove = (tag: string) => {
        removeTags([tag], sourceId)
    }

    return (
        <Container className={className}>
            <Title field={field}>{uploadSources.length > 1 && !sourceId && ` (Bulk)`}</Title>
            <Wrapper>
                <input ref={inputRef} type="text" placeholder={description} onKeyDown={onKeyDown} />
            </Wrapper>
            {displayTags.length > 0 && (
                <Tags>
                    {displayTags.map(tag => (
                        <Tag key={tag} tag={tag} onRemove={onTagRemove} />
                    ))}
                </Tags>
            )}
            {!sourceId && <Instructions field={field} />}
        </Container>
    )
}

export default CreationUploadTagsField
